import { currencyOptions } from "@/common/const";
import { fieldServiceTypeOptions } from "@/common/const/filter-options";
import fieldServiceHoursOptions from "@/common/const/filter-options/fieldServiceHours.options";
import quoteCreationTypeOptions from "@/common/const/quote/quoteCreationTypes.const";
import { FormFieldsStrategyType } from "@/common/types";

const fieldServiceQuoteLineFormStrategy: FormFieldsStrategyType[] = [
  {
    label: "Currency",
    name: "currency",
    readonly: true,
    required: true,
    inputType: "select",
    options: currencyOptions,
  },
  {
    inputType: "text",
    name: "sadsdsd",
    label: "asdasd",
    required: false,
    wrapperClassName: "hidden",
  },
  {
    inputType: "text",
    label: "OTE",
    name: "OTE",
    required: true,
  },
  {
    inputType: "select",
    label: "Quote Type",
    required: false,
    readonly: false,
    name: "quoteType",
    options: quoteCreationTypeOptions,
  },
  {
    inputType: "select",
    label: "Field Service Type",
    name: "fieldServiceType",
    required: true,
    options: fieldServiceTypeOptions,
  },
  {
    inputType: "select",
    label: "Hours Type",
    name: "hoursType",
    required: true,
    options: fieldServiceHoursOptions,
  },

  {
    inputType: "text",
    label: "No. of Hours",
    name: "noOfHours",
    required: true,
    pattern: /^[2-8]$/,
    errorMessage: "The value must be an integer between 2 and 8.",
  },

  {
    inputType: "text",
    label: "Extra Hours Rate",
    name: "extraHoursRate",
    required: true,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: true,
  },
  {
    inputType: "select",
    label: "Network Status",
    name: "networkStatus",
    required: false,
    options: [
      {
        label: "Off Net",
        value: "OfNet",
      },
      {
        label: "Near Net",
        value: "NearNet",
      },
      {
        label: "On Net",
        value: "OnNet",
      },
    ],
  },
  {
    inputType: "select",
    label: "The source of the price",
    name: "source",
    required: false,
    readonly: true,
    options: [
      {
        label: "Manual",
        value: "manual",
      },
      {
        label: "Building List",
        value: "BuildingList",
      },
      {
        label: "Country Coverage",
        value: "CountryCoverage",
      },
    ],
  },
  {
    inputType: "textarea",
    label: "Note",
    name: "description",
    required: false,
  },
];
export default fieldServiceQuoteLineFormStrategy;
